
import Util from "./Util"
import { store } from '@/store/store.js';

export let opts = {
  debounce: 200,
  views: [
    {
      view: 'mobile',
      windowWidth: 479,
      fontSize: 18,
      minFontSize: 1
    },
    {
      view: 'tablet',
      windowWidth: 1024,
      fontSize: 38,
      minFontSize: 1
    },
    {
      view: 'desktop',
      windowWidth: 1440,
      fontSize: 18,
      minFontSize: 12,
      xmaxFontSize: 23
    }
  ]
}

const init = (settings) => {
  if (settings) opts = settings;     
  detectView();
  window.addEventListener("resize", detectView)
  if (Util.isTouchDevice()) Util.addClass(document.body, 'istouch')

  // Manually resize to hot-fix on certain browsers( Galaxy s9 and Chrome small)
  setTimeout(()=>{
    window.dispatchEvent(new Event('resize'));
  }, 50)
}

const detectView = () => {
  let active = false;
  let body = document.body;
  setTimeout(() => {
    if (active) return false;
    active = true;
    const views = opts.views.sort((a, b) => b.windowWidth-a.windowWidth);
    const width = document.body.clientWidth;
    let view = views[0];
    for(var i=0,c=views.length;i<c;i++) {
      Util.removeClass(body, views[i].view);
      if (width <= views[i].windowWidth) view = views[i];
    }
    Util.addClass(body, view.view)
    let size = (view.fontSize*width/view.windowWidth).toFixed(1);
    if (size < view.minFontSize) size = view.minFontSize;
    if (view.maxFontSize && size > view.maxFontSize) size = view.maxFontSize;
    document.documentElement.style.fontSize = size+"px";
    active = false;
    if(view.view) store.commit('setViewType', view.view);
  },opts.debounce);
}

export default { init };
